/**
 * Quest tracker (the side block) and the Journal button's count badge.
 *
 * One slice of the base-view stylesheet; see styles/index.ts.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export below is
 * one template literal and a stray backtick terminates it. Write class names
 * in plain text.
 */
export default `
/* ── Quest tracker ────────────────────────────────────────────────────────
   Right edge, under the Sign-out button (top 12 / right 12, outside this
   DOM). Below every window scrim, so an open panel dims it like the HUD. */
.bv-qt {
  position: absolute; top: 60px; right: 12px; z-index: 4; width: 252px;
  display: block; padding: 9px 12px 10px; text-align: left; cursor: pointer;
  font: 12px/1.35 var(--font-technical); color: var(--bone);
  border: 1px solid var(--brass); border-radius: var(--radius-panel);
  background: linear-gradient(170deg, rgba(42,31,20,0.4), rgba(20,14,9,0.4));
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.04), 0 2px 8px rgba(0,0,0,0.3);
  text-shadow: 0 1px 2px rgba(0,0,0,0.6);
  border-color: rgba(171,138,83,0.5); touch-action: manipulation;
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}
.bv-qt[hidden] { display: none; }
/* Resting state is see-through so the playfield shows; hover, keyboard focus
   and press all firm it up. Hover only enhances: nothing depends on it. */
.bv-qt:hover, .bv-qt:focus-visible, .bv-qt:active {
  border-color: var(--brass-hot);
  background: linear-gradient(170deg, rgba(42,31,20,0.94), rgba(20,14,9,0.94));
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.06), inset 0 0 14px rgba(0,0,0,0.5),
              0 4px 12px rgba(0,0,0,0.5);
}
@media (prefers-reduced-motion: reduce) {
  .bv-qt { transition: none; }
}
.bv-qt-head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 6px; padding-bottom: 5px; border-bottom: 1px solid var(--line);
  color: var(--brass-bright); font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase;
}
.bv-qt-total { color: var(--bone-dim); }
.bv-qt-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 9px; }
.bv-qt-row {
  display: grid; grid-template-columns: 1fr auto; column-gap: 8px; row-gap: 1px;
  padding-left: 8px; border-left: 2px solid var(--brass);
}
.bv-qt-row[data-source="job"] { border-left-color: var(--bone-faint); }
.bv-qt-name { grid-column: 1 / -1; color: var(--bone); font-weight: 700; letter-spacing: 0.03em; }
.bv-qt-task { color: var(--bone-dim); font-size: 11px; min-width: 0; }
.bv-qt-count { color: var(--brass-hot); font-size: 11px; font-weight: 700; font-variant-numeric: tabular-nums; }
.bv-qt-bar {
  grid-column: 1 / -1; height: 3px; margin-top: 3px;
  background: #150f08; border: 1px solid rgba(122,90,48,0.3);
}
.bv-qt-fill { display: block; height: 100%; background: linear-gradient(90deg, #4a3210, var(--brass-hot)); }
.bv-qt-ready { border-left-color: var(--moss); }
.bv-qt-ready .bv-qt-task { color: var(--moss); }
.bv-qt-ready .bv-qt-fill { background: var(--moss); }
.bv-qt-more { display: block; margin-top: 8px; color: var(--bone-faint); font-size: 10px; }
.bv-qt-more[hidden] { display: none; }
/* Phones skip it: the block would sit over the playfield, and the count on the
   Journal button already says there is something to look at. */
@media (max-width: 640px) {
  .bv-qt { display: none; }
}

/* ── Journal count badge ──────────────────────────────────────────────────
   Top-right of the button, overflowing it slightly like the level badge. */
.bv-ab-count {
  position: absolute; top: -6px; right: -6px; z-index: 1;
  min-width: 18px; height: 18px; padding: 0 5px; box-sizing: border-box;
  display: flex; align-items: center; justify-content: center;
  font: 700 10px var(--font-technical); color: #1a1208;
  background: var(--brass-hot); border: 1px solid #120d08; border-radius: 9px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.7);
  pointer-events: none;
}
.bv-ab-count[hidden] { display: none; }
`;
